import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "../../components/navBar";

const GameShowDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [gameShow, setGameShow] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchGameShow = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/gameshows/${id}`);
        if (!response.ok) {
          throw new Error('Failed to fetch game show details');
        }
        const data = await response.json();
        setGameShow(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchGameShow();
  }, [id]);

  if (loading) {
    return (
      <div className="bg-gray-900 px-4 sm:px-6 lg:px-20 min-h-screen flex items-center justify-center">
        <p className="text-white">Loading...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-gray-900 px-4 sm:px-6 lg:px-20 min-h-screen flex items-center justify-center">
        <p className="text-white">Error: {error}</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-900">
      <Navbar />
      <div className="pt-24 px-4 sm:px-6 lg:px-16">
        <div className="container mx-auto max-w-4xl">
          {gameShow && (
            <div className="bg-gray-800 rounded-lg overflow-hidden shadow-lg">
              <img
                src={gameShow.profileImage}
                alt={gameShow.name}
                className="w-full h-64 object-cover"
              />
              <div className="p-6">
                <h1 className="text-white text-2xl font-bold mb-4">{gameShow.name}</h1>
                <p className="text-gray-400 mb-4">{gameShow.description}</p>
                <div className="text-gray-300 mb-6">
                  <p className="mb-2">
                    <span className="font-semibold">Date:</span>{' '}
                    {new Date(gameShow.date).toLocaleDateString()}
                  </p>
                  <p>
                    <span className="font-semibold">Time:</span>{' '}
                    {gameShow.startTime}
                  </p>
                </div>
                <button
                  onClick={() => navigate(`/gameshow/${id}/play`)}
                  className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg transition duration-200"
                >
                  Start Game Show
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GameShowDetail;
